<template>
  <div class="input-wrapper hd">
    <slot
      :condition="condition"
      :searchData="searchData"
      :pickerOptions="pickerOptions"
      :filterDownData="filterDownData"
    />
  </div>
</template>
<script>
import pickerOptions from 'mixins/pickerOptions/'
import filterDownData from 'mixins/filterDownData'

export default {
  name: 'SearchComponent',
  mixins: [pickerOptions, filterDownData],
  props: {
    condition: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String
    },
    id: {
      type: String,
      default: '1'
    }
  },
  methods: {
    /**
     * 筛选数据
     */
    searchData() {
      const type = this.type
      const data = this._returnSearchData()
      this.$emit(
        'updateData',
        vm => {
          const routeName = this.$route.name
          switch (routeName) {
            case 'vipList':
              vm._getVipList(data)
              break
            case 'addNewCoupon':
              vm._getVipList(data)
              break
            case 'vipIntegral':
              vm._getVipIntegralList(data)
              break
            case 'vipCheck':
              Object.assign(data, { audit_status: this.id })
              vm._getSommelierList(data, type)
              break
            case 'vipCheckIn':
              vm._getSignList(data)
              break
            case 'vipRecharge':
              vm._getVipRechargeList(data)
          }
        },
        '',
        type
      )
    },
    /**
     * 返回搜索条件
     * @private
     */
    _returnSearchData() {
      let {
        name,
        phone,
        jf1,
        jf2,
        id,
        gender,
        level,
        activity,
        checkInArea,
        registerTime,
        rechargeTime,
        rechargeType,
        rechargeOpearator
      } = this.condition
      if (!checkInArea) {
        checkInArea = []
      }
      const data = {
        member_name: name,
        member_mobile: phone,
        start_points: jf1,
        end_points: jf2,
        recommend_member_id: id,
        member_sex: gender,
        level_id: level,
        start_time: registerTime
          ? registerTime[0]
          : rechargeTime
          ? rechargeTime[0]
          : '',
        end_time: registerTime
          ? registerTime[1]
          : rechargeTime
          ? rechargeTime[1]
          : '',
        liveness: activity,
        province_id: checkInArea.length === 1 ? checkInArea[0] : '',
        city_id: checkInArea.length !== 1 ? checkInArea[1] : '',
        recharge_type: rechargeType,
        operator: rechargeOpearator
      }
      this.utils._checkSearchCondition(data)
      return data
    }
  }
}
</script>
